import { Button, Form, ListGroup } from 'react-bootstrap';
import { useRef, useState } from 'react';
import { useOutletContext } from 'react-router';
import { faMagnifyingGlass, faCircleXmark as lightXmark } from '@fortawesome/pro-light-svg-icons';
import { faCircleXmark as solidXmark } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useQuestionSearchContext } from '../context';
import HesSpinner from '../../../../../components/loadingOverlay/hesSpinner';
import CustomToast from '../../../../../components/Toast';

const QuestionId = () => {
  const [keyword, setKeyword] = useState('');
  const outletContext = useOutletContext();
  const [clearHover, setClearHover] = useState(false);
  const searchBoxRef = useRef();
  const questionSearchContext = useQuestionSearchContext();

  const handleQuestionIdChange = (e) => {
    if (e.target.value.length > 0) {
      e.target.value = e.target.value.replace(/\D/g, '');
    }

    setKeyword(e.target.value);
  };

  const SearchQuestions = () => {
    if (keyword > 2147483647) {
      CustomToast('Invalid question ID', 'error');
      return;
    }

    var searchRequest = {
      keyword: keyword,
      pageNumber: 1,
      pageSize: 25,
      courseIds: [],
      levels: []
    };
    outletContext.initializeQuestionIdSearch(searchRequest);
  };

  const handleClearSearch = () => {
    searchBoxRef.current.value = '';
    searchBoxRef.current.focus();
    setKeyword('');
  };

  return (
    <div className='d-flex flex-row gap-2 align-items-center castleQuestionsSearchBox'>

      {outletContext.courseFilters.isError && <div className='d-flex w-100 justify-content-center align-items-center'>
        <button style={{ color: '#F84646', fontSize: '1.15rem', border: 'none', background: 'none' }} onClick={() => outletContext.fetchCourseFilters()}>There was an error getting your courses. Click to try again</button>
      </div>}

      {outletContext.courseFilters.isLoading && <div className='d-flex flex-row w-100 justify-content-center align-items-center'>
        <HesSpinner width='2%' />
        <span style={{ fontSize: '2em' }} className='ms-2'>Getting your courses...</span>
      </div>}

      {!outletContext.courseFilters.isError && !outletContext.courseFilters.isLoading &&
        <>
          <ListGroup.Item className='mx-1 w-100'>
            <Form.Group>
              <div>
                <Form.Control style={{ paddingLeft: '35px', paddingRight: '35px' }} type='text' placeholder='Question ID' ref={searchBoxRef}
                  onChange={(e) => handleQuestionIdChange(e)}
                  onKeyUp={(e) => { if (keyword?.length > 0 && e.key == 'Enter') SearchQuestions(); }}
                />
                <FontAwesomeIcon className='searchIcon' icon={faMagnifyingGlass} />
                <FontAwesomeIcon className={`clearSearchIcon ${keyword?.length > 0 ? '' : 'd-none'}`}
                  icon={clearHover ? solidXmark : lightXmark}
                  onMouseEnter={() => setClearHover(true)}
                  onMouseLeave={() => setClearHover(false)}
                  onClick={() => handleClearSearch()} />
              </div>
            </Form.Group>
          </ListGroup.Item>
          <Button variant='castleWhite btn-width' disabled={questionSearchContext.isSearching || keyword?.length <= 0} onClick={() => SearchQuestions()}>Search</Button>
        </>
      }
    </div>
  );
};

export default QuestionId;
